// T028: Create TanStack Query configuration

import { QueryClient } from '@tanstack/react-query'

/**
 * Global query client configuration
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
})

/**
 * Query keys for consistent cache management
 */
export const queryKeys = {
  feed: (username: string, offset: number = 0, limit: number = 20) => [
    'feed',
    username,
    { offset, limit },
  ],
  post: (author: string, permlink: string) => ['post', author, permlink],
  comments: (author: string, permlink: string) => ['comments', author, permlink],
  profile: (username: string) => ['profile', username],
  userPosts: (username: string, offset: number = 0) => ['userPosts', username, { offset }],
  authorPosts: (username: string, offset: number = 0) => ['authorPosts', username, { offset }],
  rc: (username: string) => ['rc', username],
  notifications: (username: string) => ['notifications', username],
  notificationsInfinite: (username: string) => ['notifications', username, 'infinite'],
  search: (query: string, filters: Record<string, unknown> = {}) => ['search', query, filters],
  searchInfinite: (query: string, filters: Record<string, unknown> = {}) => [
    'search',
    query,
    filters,
    'infinite',
  ],
}
